<template>
  <div class="pos-rel home-cat-search-header custom-container-xl"
       :class="wrapperClass" v-if="shouldRender">
    <div class="col-12 filter-section-title">
      {{ t(groupTitle, {namespace: 'GlassesFilteringComponent'}) }}
    </div>
    <div class="col-12 pos-rel total-number-link">
      <a :href="this.url" v-if="this.productsCount > 0" >
        {{ t('find.your.glasses.generic.no.prefix', {namespace: 'GlassesFilteringComponent'}) }}
        <span>{{ this.productsCount }}</span>
        {{ t(totalNumberOfProductsLang, {namespace: 'GlassesFilteringComponent'}) }}
      </a>
    </div>
    <div class="category-filter">
      <div class="filter-wrapper-title" v-for="(category, index) in this.categories" :key="category.id"
           @click="setSelectedCategory(category.slug)">
        <div v-if="index !== 0" class="text-uppercase category category-link" key="category.slug"
             :class="{ 'active': isSelectedCategory(category.slug) }">
          {{ category.name }}
        </div>
      </div>
    </div>
    <div class="filter-items-wrapper col-12 col-lg-9">
      <div class="tag-values-wrapper">
        <div class="filter-title-mobile">Brands</div>
        <div class="homeSearchCheckBoxWrap">
          <input type="text" v-model="searchQuery" placeholder="Search vendors"
                 class="search-input-item form-control">
          <div class="text-center tag-values-item-vendor checkbox"
               v-for="(vendor, key) in vendors" :key="key"
               v-show="searchQuery.length < 2"
               >
            <input :class="isActiveVendor(vendor.vendor_slug)"
                   :id="vendor.name"
                   type="checkbox"
                   @click="toggleVendorSelection(vendor.vendor_slug)"
                   class="checkbox-input">
            <label :for="vendor.name">{{ vendor.name }}</label>
          </div>
          <div class="text-center tag-values-item-vendor checkbox"
               v-for="(filteredVendor) in filteredVendors"
               v-show="filteredVendors && searchQuery.length >= 2"
               :key="filteredVendor.id">
            <input :id="uniqueIdPrefix(filteredVendor.id)" type="checkbox" @click="toggleVendorSelection(filteredVendor.vendor_slug)" class="checkbox-input">
            <label :for="uniqueIdPrefix(filteredVendor.id)">{{ filteredVendor.name }}</label>
          </div>
          <div class="text-center checkbox"
               v-show="filteredVendors.length == 0 && searchQuery.length >= 2">
            No results found...
          </div>
        </div>
      </div>
      <div class="tag-values-wrapper" v-for="(tagGroup, key) in this.groupedTags" :key="key">
        <div class="filter-title-mobile">{{ groupedTags[key].GroupCatName }}</div>
        <div class="homeSearchCheckBoxWrap">
          <div class="text-center tag-values-item checkbox" v-for="tag in tagGroup.tags"
               :key="tag.id"
               @click="toggleTagSelection(tagGroup.GroupCatSlug,tag.slug, tagGroup.GroupCatId)"
               :class="{ 'active': isSelectedTag(tagGroup.GroupCatSlug, tag.slug, tagGroup.GroupCatId),'tag-values-item-with-image': tag.tag_image }"
          >
            <div v-if="tag.tag_image" class="tag-image">
              <img :src="getProductImageUrl(tag.tag_image)" :alt="tag.name" class="home-cat-search-img">
              <span>{{ tag.name }}</span>
            </div>
            <div v-else>
              <span>{{ tag.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-12 home-cat-search-total prod-total-number">
      <div  class="all-cats-no-text">
        <div v-show="this.productsCount > 0">
          {{ this.productsCount }} {{ t(totalNumberOfProductsLang, { namespace: 'GlassesFilteringComponent' }) }}
        </div>
        <a :href="this.url" v-if="this.productsCount > 0" >
          {{ t('see.more.button.glasses', { namespace: 'GlassesFilteringComponent' }) }}
        </a>
        <div v-else class="no-products-found-wrapper">
          {{ t('no.products.found', { namespace: 'GlassesFilteringComponent' }) }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import glassesGroupFilteringMixin from '../mixins/glassesGroupFilteringMixin'

export default {
  name: 'GlassesGroupFilteringMobile',
  mixins: [glassesGroupFilteringMixin],
  data () {
    return {
      shouldRender: window.innerWidth <= 768
    }
  }
}
</script>

<style scoped>
.filter-titles-wrapper {
  user-select: none;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: black;
  color: white;
  border-radius: 36px;
  padding: 15px;
  margin-bottom: 1rem;
}

@media screen and (max-width: 768px) {
  .filter-titles-wrapper {
    display: none;
  }
}


.filter-items-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1rem;
  width: 100%;
  padding: 0 15px;
}
@media screen and (max-width: 767px) {
  .filter-items-wrapper {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
  }
}
@media screen and (max-width: 450px) {
  .filter-items-wrapper {
    grid-template-columns: 1fr;
  }
}

.filter-wrapper-title {
  font-size: clamp(1rem, 2.5vw, 40px);
  font-weight: 700;
}

.tag-values-item {
  background: #D9D9D9;
  padding: clamp(10px, 2.5vw, 12px);
  border-radius: 20px;
  cursor: pointer;
  justify-content: center;
}

.tag-values-item.active {
  background: #FFCC1CFF;
}


.tag-values-item-vendor {
  display: grid;
  grid-template-columns: 13px auto;
  justify-content: start;
  align-items: center;
  text-overflow: ellipsis;
  grid-gap: 10px;
  position: relative;
    label{
      margin: 0;
      width: 100%;
      padding-left: 10px;
      overflow:hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:before {
        content:'';
        -webkit-appearance: none;
        background-color: #F7F7F7;
        border: 2px solid var(--prime1);
        padding: 10px;
        position: absolute;
        cursor: pointer;
        margin-right: 5px;
        left:0;
        top:5px;
        width:22px;
        height:22px;
        border-radius:3px;
      }
    }
    input.active{
      width:0;
      &:checked + label{
        &:before{
          background-color: var(--prime1)
        }
        &:after {
          content: '';
          position: absolute;
          top: 7px;
          left: 8px;
          width: 8px;
          height: 16px;
          border: solid var(--prime2);
          border-width: 0 2px 2px 0;
          transform: rotate(45deg)
        }
      }
    }
}
.category {
  cursor: pointer;
  margin: 5px 5px 5px 0
}

.search-input-item {
  width: 99%;
  background: #FFFFFF;
  border: 1px solid #d9d9d9;
  padding: 15px;
  border-radius: 36px;
  margin: 0 0 15px 0;
}

.category-link {
  outline: none !important;
  transition: 0.4s;
  padding: 5px 15px;
  border-radius: 36px;
  text-align: center;
}

.category-link:hover,
.category-link.active,
.category-link:focus {
  background: var(--prime2);
  color: var(--prime1);
}

.tag-image {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center; /* Vertically center grid items */
  justify-items: center; /* Horizontally center grid items */
  width: 100%; /* Full width of the container */
}

.tag-image img {
  width: 100%; /* Make the image fill the available space */
  max-width: 60px; /* Limit maximum width of the image */
  height: auto; /* Allow the height to adjust according to the width */
  object-fit: contain; /* Ensure the image fits within its dimensions */
}


.filter-title-mobile {
  font-size: clamp(1.5rem, 2.5vw, 40px);
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 1.3;
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .filter-title-mobile {
    font-size: clamp(1rem, 2.5vw, 20px);
  }
}


.category-filter {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0;
  width: 100%;
  padding-bottom: 30px;
}

@media screen and (max-width: 767px) {
  .category-filter {
    justify-content: flex-start;
    display: flex;
    width: 100%;
    overflow-x: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    flex-wrap: nowrap;
    padding-left: 15px;
    padding-right: 15px;
  }

  .category-filter::-webkit-scrollbar {
    display: none; /* Chrome, Safari, and Opera */
  }

  .category-filter .filter-wrapper-title {
    margin: 0 !important;
    display: inline-block;
  }

  .category-filter * {
    -webkit-box-flex: 0;
    -webkit-flex-grow: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }
}


.tag-values-wrapper {
  background: #FFFFFF;
  border-radius: 30px;
  box-shadow: 0 3px 6px #00000029;
  padding: 15px;
}

.homeSearchCheckBoxWrap {
  height: 100%;
  max-height: 200px;
}

.filter-section-title {
  font-size: clamp(1.5rem, 2.5vw, 40px);
  font-weight: 800;
}

.total-number-link {
  font-size: 20px;
  margin-bottom: 15px;
  line-height: 1.3;
}

.total-number-link::after {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-top: 2px solid #000;
  border-left: 2px solid #000;
  position: relative;
  top: 3px;
  transform: rotate(135deg);
  content: "";
}

.total-number-link span {
  display: inline-block;
  padding: 5px 15px;
  background-color: var(--prime1);
  color: var(--prime2);
  font-weight: 700;
  border-radius: 15px;
}


.homeSearchCheckBoxWrap {
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #ffc800 #fff;
}

.homeSearchCheckBoxWrap::-webkit-scrollbar {
  width: 8px;
}

.homeSearchCheckBoxWrap::-webkit-scrollbar-thumb {
  background-color: #ffc800;
  border-radius: 21px;
}

</style>
